module.exports = __webpack_public_path__ + "assets-cabinet/img/transfers-icon-black.269a2fac.svg";